export default function FilterIcon() {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.2933 18.7676C10.7444 19.05 11.3333 19.0771 11.8067 18.8376L13.5844 17.9341C14.1156 17.6653 14.4444 17.1232 14.4444 16.5201V12.6575L17.1533 9.90394C17.7 9.34826 18 8.61188 18 7.82807V6.58119C18 5.70928 17.3022 5 16.4444 5H7.55556C6.69778 5 6 5.70928 6 6.58119V7.82807C6 8.61188 6.3 9.35052 6.84667 9.90394L9.55556 12.6575V17.4236C9.55556 17.9748 9.83111 18.4785 10.2933 18.7676ZM7.78889 8.94393C7.49778 8.64802 7.33333 8.24595 7.33333 7.82581V6.57893C7.33333 6.45469 7.43333 6.35304 7.55556 6.35304H16.4444C16.5667 6.35304 16.6667 6.45469 16.6667 6.57893V7.82581C16.6667 8.24595 16.5022 8.64802 16.2111 8.94393L13.1111 12.095V16.5201C13.1111 16.6059 13.0644 16.685 12.9889 16.7211L11.2111 17.6246C11.0644 17.6992 10.8889 17.5908 10.8889 17.4236V12.095L7.78889 8.94393Z"
				fill="currentColor"
			/>
		</svg>
	);
}
